<template>
  <div>
    <div
      class="batchBtn"
      v-if="
        form_head_uuid === '403e15205bc248f48d8a3626571c4e56' &&
        orderList.length > 0
      "
    >
      <template v-if="checkList.length > 0">
        <el-button type="primary" @click="handleBatchApproval(1)">
          批量通过
        </el-button>
        <el-button @click="handleBatchApproval(2)">批量驳回</el-button>
      </template>
      <template v-else>
        <el-button type="primary" @click="handleAllCheck()"> 全选 </el-button>
      </template>
    </div>
    <div class="orderBox" v-if="orderList && orderList.length > 0">
      <div class="orderTableHeader">
        <span>商品</span>
        <span>单价</span>
        <span>数量</span>
        <span>总价</span>
      </div>
      <ul class="orderList">
        <li v-for="item in orderList" :key="'order' + item.id">
          <!-- 订单管理 -->
          <template
            v-if="item.form_head_uuid === '436ae44d1c60475a9b4009ca40edc11e'"
          >
            <div class="orderHeader" @click="handleCheck(item)">
              <div>
                <span class="orderTime">
                  {{ item.name }}
                </span>
              </div>
              <el-checkbox
                v-if="form_head_uuid === '403e15205bc248f48d8a3626571c4e56'"
                :value="checkItem(item)"
                @change="handleCheck(item)"
              ></el-checkbox>
            </div>
            <div
              class="orderDetail"
              v-for="(order, idx) in item.fields_value_json_show
                .cpimejxmehpaxrrz"
              :key="idx"
            >
              <img
                :src="
                  order.mnkt8dkjryhvdej3 && order.mnkt8dkjryhvdej3.length > 0
                    ? order.mnkt8dkjryhvdej3[0].url
                    : ''
                "
                alt="商品图片"
              />
              <div class="goodsName">
                <p
                  @click.stop="
                    navTo('/mall/goods/' + order.whfmbyuc1i2pavi4[0].id)
                  "
                  v-if="
                    order.whfmbyuc1i2pavi4 && order.whfmbyuc1i2pavi4.length > 0
                  "
                >
                  {{ order.whfmbyuc1i2pavi4[0].value }}
                </p>
              </div>
              <span class="unitPrice">
                {{ '￥' + (order.rojkudmmvpzinpar || 0) }}
              </span>
              <span class="num">
                {{ order.mcuilzaudpe3shlc }}
                {{
                  order.kq1qbbk7dulmlghs ? `(${order.kq1qbbk7dulmlghs})` : ''
                }}
              </span>
              <span class="num">{{ '￥' + order.nvbfzg88gv88hnt9 }}</span>
            </div>
          </template>
          <!-- 单位商品管理 -->
          <template
            v-else-if="
              item.form_head_uuid === '4b9b935758484c01bb3d8e2d1e08211f'
            "
          >
            <div class="orderHeader" @click="handleCheck(item)">
              <div>
                <span class="orderTime">
                  {{ item.fields_value_json_show.created_at }}
                </span>
                <span class="orderId">
                  {{
                    '单位商品唯一编码：' +
                    item.fields_value_json_show['cl0aot0gizkouc7p']
                  }}
                </span>
              </div>
              <el-checkbox
                v-if="form_head_uuid === '403e15205bc248f48d8a3626571c4e56'"
                :value="checkItem(item)"
                @change="handleCheck(item)"
              ></el-checkbox>
            </div>
            <div class="orderDetail">
              <img
                :src="
                  item.fields_value_json_show.in7kxcfnzrfwav2r &&
                  item.fields_value_json_show.in7kxcfnzrfwav2r.length > 0
                    ? item.fields_value_json_show.in7kxcfnzrfwav2r[0].url
                    : ''
                "
                alt="商品图片"
              />
              <div class="goodsName">
                <p
                  @click.stop="
                    navTo('/mall/goods/' + item.fields_value_json_show.id)
                  "
                >
                  {{
                    item.fields_value_json_show['6qujfllbbkwsj6t1'].length >
                      0 && item.fields_value_json_show['6qujfllbbkwsj6t1'][0]
                      ? item.fields_value_json_show['6qujfllbbkwsj6t1'][0].value
                      : ''
                  }}
                </p>
              </div>
              <span class="unitPrice">
                {{ '￥' + (item.fields_value_json_show.f93blbqlvdtdt65v || 0) }}
              </span>
              <span class="num">
                1
                {{
                  item.fields_value_json_show.y8cegh2yyvvqbzwo
                    ? `(${item.fields_value_json_show.y8cegh2yyvvqbzwo})`
                    : ''
                }}
              </span>
            </div>
          </template>
          <div class="orderfooter">
            <div v-if="item.fields_value_json_show.p6zxciihiw61mebe">
              <template>
                总金额：{{
                  '￥' + item.fields_value_json_show.p6zxciihiw61mebe
                }}
              </template>
            </div>
            <!-- 审批中才显示按钮 -->
            <div>
              <template
                v-if="form_head_uuid === '403e15205bc248f48d8a3626571c4e56'"
              >
                <el-button type="primary" @click="handleApproval(item, 1)">
                  通过
                </el-button>
                <el-button @click="handleApproval(item, 2)"> 驳回 </el-button>
              </template>
            </div>
          </div>
        </li>
      </ul>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 40, 80]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <p class="emptyTips" v-else>
      <img src="../assets/img/order.svg" alt="" />
    </p>
  </div>
</template>

<script>
import {
  todolist,
  todolistShow,
  checktodo,
  approveAllowApprovalBatchAction,
  getQueueText,
} from "@/api/platform";
export default {
  props: {
    form_head_uuid: {
      type: String,
      default: "",
    },
    form_id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      orderList: [],
      page: 1,
      total: 0,
      limit: 20,
      application_id: "270ab0c29e5411ee9b8b0242321230b4",
      checkList: [],
      loadingInstance: null,
      timer: null,
      show: true,
    };
  },
  created() {
    this.todolist();
  },
  methods: {
    checkItem(value) {
      let i = this.checkList.findIndex((el) => el.id === value.id);
      return i !== -1;
    },
    handleAllCheck() {
      this.checkList = this.orderList;
    },
    handleCheck(value) {
      if (this.form_head_uuid !== "403e15205bc248f48d8a3626571c4e56") return;
      let i = this.checkList.findIndex((el) => el.id === value.id);
      if (i !== -1) {
        this.checkList.splice(i, 1);
      } else {
        this.checkList.push(value);
      }
    },
    async todolist() {
      this.show = false;
      let obj = {
        application_id: this.application_id,
        form_head_uuid: this.form_id,
        keywords: "",
        page: this.page,
        pagesize: this.limit,
      };
      if (this.form_head_uuid === "403e15205bc248f48d8a3626571c4e56") {
        obj.type = 1;
      } else if (this.form_head_uuid === "91e9bb4eac0a48b38e8327cc9c6c23de") {
        obj.type = 2;
        obj.process_status = 2;
      } else {
        obj.type = 2;
        obj.process_status = 99;
      }
      const { result } = await todolist(obj);
      this.total = result.allcount;
      this.orderList = await Promise.all(
        result.list.map(async (el) => ({
          ...el,
          ...(await this.todolistShow(el.id, el.node_uuid, el.work_flows_uuid)),
        }))
      );
      this.show = true;
    },
    async todolistShow(id, node_uuid, work_flows_uuid) {
      const { result } = await todolistShow({
        application_id: this.application_id,
        id,
        node_uuid,
        work_flows_uuid,
      });
      return {
        fields_value_json_show: result.basicinfo.fields_value_json_show,
        form_head_uuid: result.basicinfo.form_head_uuid,
      };
    },
    // 切换页数
    handleCurrentChange(page) {
      this.page = page;
      this.todolist();
    },
    handleSizeChange(limit) {
      this.page = 1;
      this.limit = limit;
      this.todolist();
    },
    navTo(route) {
      this.$store.commit("setData", {
        form_head_uuid: this.form_head_uuid,
      });
      this.$router.push(route);
    },
    // 审批通过
    handleApproval(value, status) {
      console.log(value);
      const {
        id,
        node_uuid,
        todo_id,
        work_flows_uuid,
        fields_value_json_show,
      } = value;
      this.$confirm(
        status === 1 ? "确认审批通过？" : "确认审批驳回？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          await checktodo({
            application_id: this.application_id,
            approve_upload_file: [],
            content: "",
            data: {
              id: fields_value_json_show.id,
            },
            editjson: {},
            id,
            isedit: 0,
            node_uuid,
            rejectinfo: {},
            signature_file: "",
            todo_id,
            status,
            work_flows_uuid,
          });
          this.$message({
            type: "success",
            message: status === 1 ? "审批成功!" : "审批已驳回!",
          });
          this.page = 1;
          this.todolist();
        })
        .catch(() => { });
    },
    // 批量审批
    async handleBatchApproval(status) {
      let batch_info = this.checkList.map((el) => {
        const {
          id,
          node_uuid,
          todo_id,
          work_flows_uuid,
          fields_value_json_show,
        } = el;
        return {
          application_id: this.application_id,
          approve_upload_file: [],
          content: "",
          data: {
            id: fields_value_json_show.id,
          },
          editjson: {},
          id,
          isedit: 0,
          node_uuid,
          rejectinfo: {},
          signature_file: "",
          todo_id,
          status,
          work_flows_uuid,
        };
      });
      const { result } = await approveAllowApprovalBatchAction({
        batch_info,
      });
      this.getQueueText(result.queue_code);
      this.timer = setInterval(() => {
        this.getQueueText(result.queue_code);
      }, 1000);
      this.checkList = [];
      // 显示加载提示
      this.loadingInstance = this.$loading({
        lock: true,
        text: "正在审批中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    async getQueueText(queue_code) {
      const { result } = await getQueueText({
        queue_code,
      });
      let status = result.data.status;
      if (status === "success") {
        // 关闭加载提示
        this.loadingInstance.close();
        clearInterval(this.timer);
        // 显示成功提示
        this.$notify({
          title: "提示",
          message: result.data.message,
          type: "success",
        });
        this.page = 1;
        this.todolist();
      } else if (status === "running") {
        this.loadingInstance.text = result.data.message;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../assets/css/var.less';
@import '../css/order.less';
.batchBtn {
  display: flex;
  justify-content: flex-end;
  margin-top: -40px;
}
.orderHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ApprovalList.vue